// extracted by mini-css-extract-plugin
export default {"header":"AppDashboard_header__MbbWX","tabContainer":"AppDashboard_tabContainer__NbhFH","tableContainer":"AppDashboard_tableContainer__Ikc6P"};